<template>
  <NuxtLink
    v-if="!isStorybook && !isExternalLink"
    :to="localePath(link)"
    :rel="target === '_blank' ? 'noopener noreferrer' : null"
    :target="target"
    :aria-label="ariaLabel"
    class="atom-link"
  >
    <slot />
  </NuxtLink>
  <a
    v-else
    :href="link"
    rel="noopener noreferrer"
    :target="target ? target : '_blank'"
    :aria-label="ariaLabel"
    class="atom-link"
  >
    <slot />
  </a>
</template>

<script setup>
const props = defineProps({
    link: {
        type: String,
        default: '',
        validator: (value) => value.length > 0,
    },

    target: {
        type: String,
        default: null,
    },

    ariaLabel: {
        type: String,
        default: '',
    },
});

const isExternalLink = computed(
    () => props.link.includes('http://')
    || props.link.includes('https://')
    || props.link.includes('mailto:')
    || props.link.includes('tel:'),
);

/*
  Internationalization
*/
const localePath = useLocalePath();

/*
  Storybook
*/
const runtimeConfig = useRuntimeConfig();
const isStorybook = runtimeConfig.public.IS_STORYBOOK;
</script>
